// extracted by mini-css-extract-plugin
export default {"home":"Contact_home__6PPzv"};